import { jsxs as z, jsx as o } from "react/jsx-runtime";
import { useMemo as S } from "react";
import { _ as e } from "../../cs-Dfox81s-.js";
import "../../type-Dku6Xzl6.js";
import m from "../../hooks/useSpacingToken.js";
import { gapSpacings as p, fullSpacings as D } from "../../utils/style.js";
import '../../index30.css';const L = "_inline-layout_cm459_1", O = "_start-aligned-content_cm459_5", x = "_baseline-aligned-content_cm459_9", P = "_end-aligned-content_cm459_13", j = "_after-content_cm459_17", M = "_before-content_cm459_18", k = "_children_cm459_56", E = "_ellipsized_cm459_61", R = "_with-inline-display_cm459_69", n = {
  inlineLayout: L,
  startAlignedContent: O,
  baselineAlignedContent: x,
  endAlignedContent: P,
  afterContent: j,
  beforeContent: M,
  children: k,
  ellipsized: E,
  withInlineDisplay: R
};
function J(f) {
  const {
    className: _,
    elementRef: C,
    before: s,
    beforeContainerClassName: g,
    children: h,
    childrenContainerClassName: u,
    after: l,
    afterContainerClassName: b,
    spacing: a,
    spacingOffset: c,
    withPadding: r,
    withoutSpacingOpticalCorrection: d,
    withAdditionalInlinePadding: w,
    withEllipsizedContent: y,
    contentAlignment: t = "center",
    withInlineDisplay: A,
    ...N
  } = f, I = S(() => r ? D : p, [r]), v = m({
    spacing: a,
    modes: I,
    offset: c ?? 0,
    withAdditionalInlinePadding: w,
    withoutOpticalCorrection: d
  }), i = m({
    spacing: a,
    modes: p,
    offset: c ?? 0,
    withoutOpticalCorrection: d
  });
  return /* @__PURE__ */ z(
    "div",
    {
      ...N,
      ref: C,
      className: e(
        n.inlineLayout,
        v,
        t === "start" && n.startAlignedContent,
        t === "end" && n.endAlignedContent,
        t === "baseline" && n.baselineAlignedContent,
        A && n.withInlineDisplay,
        _
      ),
      children: [
        s && /* @__PURE__ */ o(
          "div",
          {
            className: e(
              n.beforeContent,
              i,
              g
            ),
            children: s
          }
        ),
        /* @__PURE__ */ o(
          "div",
          {
            className: e(
              n.children,
              i,
              u,
              y && n.ellipsized
            ),
            children: h
          }
        ),
        l && /* @__PURE__ */ o(
          "div",
          {
            className: e(
              n.afterContent,
              b,
              i
            ),
            children: l
          }
        )
      ]
    }
  );
}
export {
  J as default
};
